import type { GraphPath, GraphTopologyParameters } from '@ipfabric/utils';
import { isTopologyGraphMetadata } from 'components/Graph/GraphState';
import { loadGraph } from 'components/Graph/commands/loadGraph';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export interface ExpandGraphCommand {
  path: GraphPath;
}

export const expandGraph: GraphCommandFactory<ExpandGraphCommand> =
  (cmdContext, dispatch) => async (command) => {
    const { graphMetadata } = cmdContext.getState();

    if (!isTopologyGraphMetadata(graphMetadata)) {
      throw new Error('No topology graph loaded, cannot expand graph');
    }

    const parameters: GraphTopologyParameters = {
      ...graphMetadata.parameters,
      paths: [command.path, ...graphMetadata.parameters.paths],
    };
    await dispatch(loadGraph, {
      overlay: 'keep',
      parameters,
    });
  };
